import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=d368f33c&lang=pug&"
import script from "./timer.vue?vue&type=script&lang=js&"
export * from "./timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d368f33c')) {
      api.createRecord('d368f33c', component.options)
    } else {
      api.reload('d368f33c', component.options)
    }
    module.hot.accept("./timer.vue?vue&type=template&id=d368f33c&lang=pug&", function () {
      api.rerender('d368f33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/timer/timer.vue"
export default component.exports